(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram-shoppable-feed"] && !Shopify.designMode) return;
  try {
    
  class InstaFeedSection {
    constructor(section) {
      this.section = section;
      this.viewport = section.querySelector('[data-viewport]');
      this.track = section.querySelector('[data-track]');
      this.prev = section.querySelector('[data-prev]');
      this.next = section.querySelector('[data-next]');
      this.empty = section.querySelector('[data-empty]');
      this.status = section.querySelector('[data-status]');
      this.modal = section.querySelector('[data-modal]');
      this.modalMedia = section.querySelector('[data-modal-media]');
      this.modalPanel = section.querySelector('[data-modal-panel]');
      this.modalPrev = section.querySelector('[data-modal-prev]');
      this.modalNext = section.querySelector('[data-modal-next]');
      this.modalClose = section.querySelector('[data-close]');

      this.source = section.dataset.source || 'manual';
      this.proxyEndpoint = section.dataset.proxyEndpoint || '';
      this.maxItems = Number.parseInt(section.dataset.maxItems || '10', 10);
      this.mediaFilter = (section.dataset.mediaFilter || 'all').toLowerCase();
      this.autoAdvance = section.dataset.autoAdvance === 'true';
      this.autoplay = section.dataset.autoplay === 'true';
      this.muted = section.dataset.muted === 'true';

      this.labels = {
        empty: section.dataset.emptyLabel || 'No Instagram items available right now.',
        open: section.dataset.openLabel || 'Open media',
        openPost: section.dataset.openPostLabel || 'Open post',
        addDefault: section.dataset.defaultButtonLabel || 'Add to cart',
        more: section.dataset.moreLabel || 'More info',
        soldOut: section.dataset.soldOutLabel || 'Sold out',
        adding: section.dataset.addingLabel || 'Adding...',
        added: section.dataset.addedLabel || 'Added',
        addError: section.dataset.addErrorLabel || 'Error',
      };

      this.items = [];
      this.current = 0;

      this.onScroll = () => this.updateCarouselNav();
      this.onResize = () => this.updateCarouselNav();
      this.onKeyDown = (event) => this.handleKeyDown(event);
      this.onSectionClick = (event) => this.handleSectionClick(event);
      this.onModalPrevClick = () => this.moveModal(-1);
      this.onModalNextClick = () => this.moveModal(1);
      this.onModalCloseClick = () => this.closeModal();
      this.onModalBackdropClick = (event) => {
        if (event.target === this.modal) this.closeModal();
      };

      this.init();
    }

    async init() {
      this.bind();

      if (this.source === 'proxy') {
        await this.loadProxy();
      } else {
        this.collectManual();
      }

      this.updateEmptyState();
      this.updateCarouselNav();
    }

    destroy() {
      this.viewport?.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('keydown', this.onKeyDown);
      this.section.removeEventListener('click', this.onSectionClick);

      this.modalPrev?.removeEventListener('click', this.onModalPrevClick);
      this.modalNext?.removeEventListener('click', this.onModalNextClick);
      this.modalClose?.removeEventListener('click', this.onModalCloseClick);
      this.modal?.removeEventListener('click', this.onModalBackdropClick);
    }

    bind() {
      this.viewport?.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      document.addEventListener('keydown', this.onKeyDown);
      this.section.addEventListener('click', this.onSectionClick);

      this.prev?.addEventListener('click', () => this.scrollByCard(-1));
      this.next?.addEventListener('click', () => this.scrollByCard(1));

      this.modalPrev?.addEventListener('click', this.onModalPrevClick);
      this.modalNext?.addEventListener('click', this.onModalNextClick);
      this.modalClose?.addEventListener('click', this.onModalCloseClick);
      this.modal?.addEventListener('click', this.onModalBackdropClick);
    }

    collectManual() {
      const nodes = Array.from(this.track.querySelectorAll('[data-item]'));
      this.items = nodes.map((node, index) => this.readNode(node, index)).filter((item) => item.mediaUrl);

      nodes.forEach((node, index) => {
        node.dataset.index = String(index);
        this.activateManualMedia(node);
      });
    }

    activateManualMedia(node) {
      const image = node.querySelector('img[data-media-url]');
      if (image && image.dataset.mediaUrl && !image.getAttribute('src')) {
        image.src = image.dataset.mediaUrl;
      }

      const source = node.querySelector('video source[data-media-url]');
      if (source && source.dataset.mediaUrl && !source.getAttribute('src')) {
        source.src = source.dataset.mediaUrl;
        const video = source.closest('video');
        if (video) video.load();
      }
    }

    readNode(node, index) {
      return {
        id: String(index),
        mediaType: (node.dataset.mediaType || 'IMAGE').toUpperCase() === 'VIDEO' ? 'VIDEO' : 'IMAGE',
        mediaUrl: this.safeUrl(node.dataset.mediaUrl || ''),
        thumbUrl: this.safeUrl(node.dataset.thumbUrl || ''),
        caption: (node.dataset.caption || '').trim(),
        description: (node.dataset.description || '').trim(),
        permalink: this.safeUrl(node.dataset.permalink || ''),
        product: this.readProduct(node),
      };
    }

    readProduct(node) {
      const title = (node.dataset.productTitle || '').trim();
      const variantId = (node.dataset.variantId || '').trim();
      if (!title && !variantId) return null;

      return {
        title,
        url: this.safeUrl(node.dataset.productUrl || ''),
        image: this.safeUrl(node.dataset.productImage || ''),
        price: (node.dataset.price || '').trim(),
        compare: (node.dataset.compare || '').trim(),
        variantId,
        available: node.dataset.available === 'true',
        button: (node.dataset.buttonLabel || this.labels.addDefault).trim(),
        more: (node.dataset.moreLabel || this.labels.more).trim(),
      };
    }

    async loadProxy() {
      if (!this.proxyEndpoint) {
        this.items = [];
        return;
      }

      try {
        const url = new URL(this.proxyEndpoint, window.location.origin);
        if (Number.isFinite(this.maxItems) && this.maxItems > 0) {
          url.searchParams.set('limit', String(this.maxItems));
        }
        if (this.mediaFilter !== 'all') {
          url.searchParams.set('media', this.mediaFilter);
        }

        const response = await fetch(url.toString(), {
          method: 'GET',
          headers: { Accept: 'application/json' },
        });

        if (!response.ok) throw new Error('Proxy request failed');

        const payload = await response.json();
        const rows = Array.isArray(payload) ? payload : Array.isArray(payload.items) ? payload.items : [];

        this.items = rows
          .map((row, index) => this.normalizeProxyRow(row, index))
          .filter((item) => item && item.mediaUrl);

        this.renderProxySlides();
      } catch (error) {
        console.error('[insta-feed] proxy load failed', error);
        this.items = [];
      }
    }

    normalizeProxyRow(row, index) {
      if (!row || typeof row !== 'object') return null;

      const mediaType = String(row.media_type || row.mediaType || '').toUpperCase() === 'VIDEO' ? 'VIDEO' : 'IMAGE';
      const mediaUrl = this.safeUrl(row.media_url || row.mediaUrl || '');
      if (!mediaUrl) return null;

      const rawProduct = row.product && typeof row.product === 'object' ? row.product : null;
      let product = null;

      if (rawProduct) {
        product = {
          title: String(rawProduct.title || '').trim(),
          url: this.safeUrl(rawProduct.url || ''),
          image: this.safeUrl(rawProduct.image || ''),
          price: String(rawProduct.price || '').trim(),
          compare: String(rawProduct.compare_at_price || rawProduct.comparePrice || '').trim(),
          variantId: String(rawProduct.variant_id || rawProduct.variantId || '').trim(),
          available: rawProduct.available !== false,
          button: String(rawProduct.button_label || this.labels.addDefault).trim(),
          more: String(rawProduct.more_label || this.labels.more).trim(),
        };
      }

      return {
        id: String(row.id || index),
        mediaType,
        mediaUrl,
        thumbUrl: this.safeUrl(row.thumbnail_url || row.thumbnailUrl || row.media_url || row.mediaUrl || ''),
        caption: String(row.caption || '').trim(),
        description: String(row.description || '').trim(),
        permalink: this.safeUrl(row.permalink || ''),
        product,
      };
    }

    renderProxySlides() {
      this.track.innerHTML = '';

      this.items.forEach((item, index) => {
        const slide = this.createProxySlide(item, index);
        this.track.appendChild(slide);
      });
    }

    createProxySlide(item, index) {
      const slide = document.createElement('li');
      slide.className = 'insta-feed__slide';
      slide.setAttribute('role', 'listitem');

      const article = document.createElement('article');
      article.className = 'insta-feed__item';
      article.setAttribute('data-item', '');

      article.dataset.index = String(index);
      article.dataset.mediaType = item.mediaType;
      article.dataset.mediaUrl = item.mediaUrl;
      article.dataset.thumbUrl = item.thumbUrl || '';
      article.dataset.caption = item.caption || '';
      article.dataset.description = item.description || '';
      article.dataset.permalink = item.permalink || '';

      if (item.product) {
        article.dataset.productTitle = item.product.title || '';
        article.dataset.productUrl = item.product.url || '';
        article.dataset.productImage = item.product.image || '';
        article.dataset.price = item.product.price || '';
        article.dataset.compare = item.product.compare || '';
        article.dataset.variantId = item.product.variantId || '';
        article.dataset.available = item.product.available ? 'true' : 'false';
        article.dataset.buttonLabel = item.product.button || this.labels.addDefault;
        article.dataset.moreLabel = item.product.more || this.labels.more;
      }

      article.appendChild(this.createMediaWrap(item, index));
      slide.appendChild(article);

      return slide;
    }

    createMediaWrap(item, index) {
      const wrap = document.createElement('div');
      wrap.className = 'insta-feed__media-wrap';

      const openButton = document.createElement('button');
      openButton.type = 'button';
      openButton.className = 'insta-feed__media-hit';
      openButton.setAttribute('data-open', '');
      openButton.setAttribute('aria-label', `${this.labels.open} ${index + 1}`);

      if (item.mediaType === 'VIDEO') {
        const video = document.createElement('video');
        video.className = 'insta-feed__media';
        video.preload = 'metadata';
        video.muted = true;
        video.playsInline = true;
        if (item.thumbUrl) video.poster = item.thumbUrl;

        const source = document.createElement('source');
        source.src = item.mediaUrl;
        video.appendChild(source);

        openButton.appendChild(video);

        const play = document.createElement('span');
        play.className = 'insta-feed__play';
        play.setAttribute('aria-hidden', 'true');
        play.innerHTML = '&#9654;';
        openButton.appendChild(play);
      } else {
        const image = document.createElement('img');
        image.className = 'insta-feed__media';
        image.loading = 'lazy';
        image.width = 720;
        image.height = 1280;
        image.src = item.thumbUrl || item.mediaUrl;
        image.alt = item.caption || item.product?.title || '';
        openButton.appendChild(image);
      }

      wrap.appendChild(openButton);

      if (item.product) {
        wrap.appendChild(this.createProductCard(item));
      }

      return wrap;
    }

    createProductCard(item) {
      const product = item.product;

      const card = document.createElement('div');
      card.className = 'insta-feed__card';

      const imageLink = document.createElement('a');
      imageLink.className = 'insta-feed__card-image-link';
      imageLink.href = product.url || '#';

      if (product.image) {
        const image = document.createElement('img');
        image.className = 'insta-feed__card-image';
        image.src = product.image;
        image.alt = product.title || '';
        image.loading = 'lazy';
        image.width = 64;
        image.height = 64;
        imageLink.appendChild(image);
      }

      card.appendChild(imageLink);

      const content = document.createElement('div');
      content.className = 'insta-feed__card-content';

      const title = document.createElement('a');
      title.className = 'insta-feed__card-title';
      title.href = product.url || '#';
      title.textContent = product.title || '';
      content.appendChild(title);

      const priceWrap = document.createElement('p');
      priceWrap.className = 'insta-feed__card-price';

      const price = document.createElement('span');
      price.textContent = product.price || '';
      priceWrap.appendChild(price);

      if (product.compare) {
        const compare = document.createElement('span');
        compare.className = 'insta-feed__card-compare';
        compare.textContent = product.compare;
        priceWrap.appendChild(compare);
      }

      content.appendChild(priceWrap);

      const actions = document.createElement('div');
      actions.className = 'insta-feed__card-actions';

      const addButton = document.createElement('button');
      addButton.type = 'button';
      addButton.className = 'insta-feed__atc';
      addButton.setAttribute('data-atc', '');
      addButton.dataset.variantId = product.variantId || '';
      addButton.textContent = product.available ? product.button || this.labels.addDefault : this.labels.soldOut;
      if (!product.available || !product.variantId) {
        addButton.disabled = true;
      }
      actions.appendChild(addButton);

      if (item.permalink) {
        const ext = document.createElement('a');
        ext.className = 'insta-feed__ext';
        ext.href = item.permalink;
        ext.target = '_blank';
        ext.rel = 'noopener noreferrer';
        ext.setAttribute('aria-label', product.more || this.labels.more);
        ext.innerHTML = '<span aria-hidden="true">&#8599;</span>';
        actions.appendChild(ext);
      }

      content.appendChild(actions);
      card.appendChild(content);

      return card;
    }

    updateEmptyState() {
      const noItems = this.items.length === 0;

      if (this.empty) {
        this.empty.classList.toggle('is-hidden', !noItems);
        if (noItems) this.empty.textContent = this.labels.empty;
      }

      if (noItems) {
        if (this.prev) this.prev.disabled = true;
        if (this.next) this.next.disabled = true;
      }
    }

    scrollByCard(direction) {
      if (!this.viewport) return;
      const firstSlide = this.track.querySelector('.insta-feed__slide');
      if (!firstSlide) return;

      const gap = Number.parseFloat(getComputedStyle(this.track).gap || '0') || 0;
      const cardWidth = firstSlide.getBoundingClientRect().width;
      const amount = cardWidth + gap;

      this.viewport.scrollBy({
        left: amount * direction,
        behavior: 'smooth',
      });
    }

    updateCarouselNav() {
      if (!this.viewport) return;

      const maxLeft = Math.max(this.viewport.scrollWidth - this.viewport.clientWidth, 0);
      const atStart = this.viewport.scrollLeft <= 2;
      const atEnd = this.viewport.scrollLeft >= maxLeft - 2;

      if (this.prev) this.prev.disabled = atStart || this.items.length === 0;
      if (this.next) this.next.disabled = atEnd || this.items.length === 0;
    }

    handleSectionClick(event) {
      const openButton = event.target.closest('[data-open]');
      if (openButton) {
        const itemNode = openButton.closest('[data-item]');
        if (!itemNode) return;
        const index = Number.parseInt(itemNode.dataset.index || '0', 10);
        this.openModal(index);
        return;
      }

      const addButton = event.target.closest('[data-atc]');
      if (addButton) {
        event.preventDefault();
        const variantId = addButton.dataset.variantId || '';
        if (!variantId) return;
        this.addToCart(addButton, variantId);
      }
    }

    openModal(index) {
      if (!this.modal || this.items.length === 0) return;

      this.current = this.clamp(index, 0, this.items.length - 1);
      this.renderModal(this.autoplay);

      if (!this.modal.open) this.modal.showModal();
      document.documentElement.classList.add('overflow-hidden');

      if (this.modalClose) this.modalClose.focus();
    }

    closeModal() {
      this.stopModalVideo();
      if (this.modal?.open) this.modal.close();
      document.documentElement.classList.remove('overflow-hidden');
    }

    handleKeyDown(event) {
      if (!this.modal?.open) return;

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.moveModal(-1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.moveModal(1);
      }
    }

    moveModal(step) {
      const nextIndex = this.current + step;
      if (nextIndex < 0 || nextIndex > this.items.length - 1) {
        this.updateModalNav();
        return;
      }

      this.current = nextIndex;
      this.renderModal(this.autoplay);
    }

    renderModal(autoplay) {
      const item = this.items[this.current];
      if (!item || !this.modalMedia || !this.modalPanel) return;

      this.stopModalVideo();
      this.modalMedia.innerHTML = '';
      this.modalPanel.innerHTML = '';

      if (item.mediaType === 'VIDEO') {
        const video = document.createElement('video');
        video.controls = true;
        video.playsInline = true;
        video.preload = 'metadata';
        if (this.muted) video.muted = true;
        if (item.thumbUrl) video.poster = item.thumbUrl;

        const source = document.createElement('source');
        source.src = item.mediaUrl;
        video.appendChild(source);

        video.addEventListener('ended', () => {
          if (this.autoAdvance && this.current < this.items.length - 1) {
            this.current += 1;
            this.renderModal(true);
            return;
          }
          this.updateModalNav();
        });

        this.modalMedia.appendChild(video);

        if (autoplay) {
          video.play().catch(() => {});
        }
      } else {
        const image = document.createElement('img');
        image.src = item.mediaUrl;
        image.alt = item.caption || item.product?.title || '';
        this.modalMedia.appendChild(image);
      }

      if (item.caption) {
        const caption = document.createElement('p');
        caption.className = 'insta-feed-modal__caption';
        caption.textContent = item.caption;
        this.modalPanel.appendChild(caption);
      }

      if (item.description && item.description !== item.caption) {
        const description = document.createElement('p');
        description.className = 'insta-feed-modal__caption';
        description.textContent = item.description;
        this.modalPanel.appendChild(description);
      }

      if (item.product) {
        this.modalPanel.appendChild(this.createModalProduct(item));
      } else if (item.permalink) {
        const openPost = document.createElement('a');
        openPost.className = 'insta-feed-modal__btn';
        openPost.href = item.permalink;
        openPost.target = '_blank';
        openPost.rel = 'noopener noreferrer';
        openPost.textContent = this.labels.openPost;
        this.modalPanel.appendChild(openPost);
      }

      this.updateModalNav();
      this.announce(`Showing item ${this.current + 1} of ${this.items.length}`);
    }

    createModalProduct(item) {
      const product = item.product;

      const wrapper = document.createElement('div');
      wrapper.className = 'insta-feed-modal__product';

      if (product.image) {
        const image = document.createElement('img');
        image.src = product.image;
        image.alt = product.title || '';
        image.width = 76;
        image.height = 76;
        wrapper.appendChild(image);
      }

      const content = document.createElement('div');

      const title = document.createElement('h3');
      title.className = 'insta-feed-modal__title';
      const titleLink = document.createElement('a');
      titleLink.href = product.url || '#';
      titleLink.textContent = product.title || '';
      title.appendChild(titleLink);
      content.appendChild(title);

      const priceWrap = document.createElement('p');
      priceWrap.className = 'insta-feed-modal__price';

      const price = document.createElement('span');
      price.textContent = product.price || '';
      priceWrap.appendChild(price);

      if (product.compare) {
        const compare = document.createElement('span');
        compare.className = 'compare';
        compare.textContent = product.compare;
        priceWrap.appendChild(compare);
      }

      content.appendChild(priceWrap);

      const actions = document.createElement('div');
      actions.className = 'insta-feed-modal__actions';

      const addButton = document.createElement('button');
      addButton.type = 'button';
      addButton.className = 'insta-feed-modal__btn primary';
      addButton.setAttribute('data-atc', '');
      addButton.dataset.variantId = product.variantId || '';
      addButton.textContent = product.available ? product.button || this.labels.addDefault : this.labels.soldOut;
      if (!product.available || !product.variantId) {
        addButton.disabled = true;
      }
      actions.appendChild(addButton);

      const moreButton = document.createElement('a');
      moreButton.className = 'insta-feed-modal__btn';
      moreButton.href = product.url || item.permalink || '#';
      if (item.permalink) {
        moreButton.target = '_blank';
        moreButton.rel = 'noopener noreferrer';
      }
      moreButton.textContent = product.more || this.labels.more;
      actions.appendChild(moreButton);

      content.appendChild(actions);
      wrapper.appendChild(content);

      return wrapper;
    }

    stopModalVideo() {
      const video = this.modalMedia?.querySelector('video');
      if (!video) return;
      video.pause();
      video.currentTime = 0;
    }

    updateModalNav() {
      if (this.modalPrev) this.modalPrev.disabled = this.current <= 0;
      if (this.modalNext) this.modalNext.disabled = this.current >= this.items.length - 1;
    }

    announce(message) {
      if (this.status) this.status.textContent = message;
    }

    async addToCart(button, variantId) {
      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = this.labels.adding;

      const ensureDeliveryLocation = window.ThemeDeliveryLocation?.ensure;
      if (typeof ensureDeliveryLocation === 'function' && !(await ensureDeliveryLocation())) {
        button.textContent = originalText || this.labels.addDefault;
        button.disabled = false;
        return;
      }

      try {
        const addUrl = window.Theme?.routes?.cart_add_url;
        if (!addUrl) throw new Error('cart_add_url not found');

        const response = await fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1 }],
          }),
        });

        if (!response.ok) throw new Error('Add to cart failed');

        button.textContent = this.labels.added;
        this.openCartDrawer();
      } catch (error) {
        console.error('[insta-feed] add to cart failed', error);
        button.textContent = this.labels.addError;
      } finally {
        window.setTimeout(() => {
          button.textContent = originalText || this.labels.addDefault;
          if (variantId) button.disabled = false;
        }, 1200);
      }
    }

    openCartDrawer() {
      const drawer = document.querySelector('cart-drawer-component');

      if (drawer) {
        if (typeof drawer.open === 'function') {
          drawer.open();
          return;
        }
        if (typeof drawer.showDialog === 'function') {
          drawer.showDialog();
          return;
        }
        if (typeof drawer.toggleDialog === 'function') {
          drawer.toggleDialog(true);
          return;
        }
      }

      const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger instanceof HTMLElement) trigger.click();
    }

    clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    safeUrl(value) {
      if (typeof value !== 'string') return '';
      const trimmed = value.trim();
      if (!trimmed) return '';
      if (trimmed.startsWith('/')) return trimmed;

      try {
        const parsed = new URL(trimmed, window.location.origin);
        if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
          return parsed.toString();
        }
        return '';
      } catch (_) {
        return '';
      }
    }
  }

  const instances = new WeakMap();

  function init(root = document) {
    const sections = root.querySelectorAll('[data-instafeed]');
    sections.forEach((section) => {
      if (instances.has(section)) return;
      instances.set(section, new InstaFeedSection(section));
    });
  }

  function destroy(root = document) {
    const sections = root.querySelectorAll('[data-instafeed]');
    sections.forEach((section) => {
      const instance = instances.get(section);
      if (!instance) return;
      instance.destroy();
      instances.delete(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
